import type { TimeZone } from '@iheartjane/types';

const railsTimeZones: Record<string, TimeZone> = Object.freeze({
  Alaska: 'America/Juneau',
  Arizona: 'America/Phoenix',
  'Central Time (US & Canada)': 'America/Chicago',
  'Eastern Time (US & Canada)': 'America/New_York',
  Hawaii: 'Pacific/Honolulu',
  'Indiana (East)': 'America/Indiana/Indianapolis',
  'Mountain Time (US & Canada)': 'America/Denver',
  'Pacific Time (US & Canada)': 'America/Los_Angeles',
  'Puerto Rico': 'America/Puerto_Rico',
});

/**
 * Translates an ActiveSupport TimeWithZone into an IANA time zone id
 */
export const timezone = (timezone: TimeZone): TimeZone => {
  if (Object.keys(railsTimeZones).includes(timezone)) {
    return railsTimeZones[timezone];
  }

  return timezone;
};

export const shopperTimeZone = (): TimeZone =>
  Intl.DateTimeFormat().resolvedOptions().timeZone as TimeZone;

/**
 * date-fns does not currently provide the convenient zone names for
 * the zone offsets we support, so we'll borrow from the Intl API.
 * @example 'PDT', 'PST', 'EST'
 */
export const timezoneToken = (timeZone: TimeZone) => {
  return Intl.DateTimeFormat('en-US', {
    timeZone,
    timeZoneName: 'short',
  })
    .format(new Date())
    .split(', ')[1];
};
